import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { logout } from "utils/auth";
import {
  HStack,
  Icon,
  Link,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  Text,
  Flex
} from "@chakra-ui/react";
import { useUser } from "context/user";
import { BsChevronDown } from "react-icons/bs";
import { ImExit, ImUser } from "react-icons/im";
import { MdLockOutline } from "react-icons/md";

const CurrentUserDropdown: React.FC = () => {
  const { user } = useUser()!;

  return (
    <>
      {user && user.id ? (
        <Popover trigger="click">
          <PopoverTrigger>
            <HStack
              rounded="xl"
              spacing={3}
              p={2}
              _hover={{
                bgColor: "gray.700",
                cursor: "pointer"
              }}
            >
              <Text fontSize="md" fontWeight="600">
                {user.first_name
                  ? `${user?.first_name} ${user?.last_name}`
                  : user.username}
              </Text>
              <Icon w={6} h={6} as={BsChevronDown} />
            </HStack>
          </PopoverTrigger>
          <PopoverContent
            fontSize="md"
            fontWeight="500"
            border="0"
            bg="gray.700"
            color="white"
            width="220px"
            margin="0 auto"
            right="0"
            boxShadow="0px 4px 7px -1px rgba(0, 0, 0, 0.25)"
          >
            <PopoverBody p={0} overflow="hidden">
              <Link as={RouterLink} to="/profile">
                <Flex p={4} borderRadius="md" _hover={{ bg: "gray.600" }}>
                  <Icon as={ImUser} w={6} h={6} mr={3}></Icon>
                  Update Profile
                </Flex>
              </Link>
              <Link as={RouterLink} to="/profile/password">
                <Flex p={4} borderRadius="md" _hover={{ bg: "gray.600" }}>
                  <Icon as={MdLockOutline} w={6} h={6} mr={3}></Icon>
                  Change Password
                </Flex>
              </Link>
              <Link as={RouterLink} to="/login" onClick={logout}>
                <Flex p={4} borderRadius="md" _hover={{ bg: "gray.600" }}>
                  <Icon as={ImExit} w={6} h={6} mr={3}></Icon>
                  Logout
                </Flex>
              </Link>
            </PopoverBody>
          </PopoverContent>
        </Popover>
      ) : (
        <Link as={RouterLink} to="/login">
          Login
        </Link>
      )}
    </>
  );
};

export default CurrentUserDropdown;
